import { getLimepayApiHost } from 'utils/env';

import { handleResponse } from '../utils';
import { GetPlatformConfigResponse } from './platform.types';

export const getPlatformConfig = async (slug: string): Promise<GetPlatformConfigResponse> =>
  fetch(`${await getLimepayApiHost()}/config/platform?m=${slug}`).then(handleResponse);
